import { ResponseLink } from '@core/models/api/response.api.model';

export function getLinkFromId(id: string, url: string): ResponseLink {
    if (!!id && !!url) {
        return  { href: `${url}/${id}` };
    }

    return { href: '' };
}

export function getLastFragmentFromLink(link: ResponseLink) {
    if (!link || !link.href) {
        return '';
    }
    const url = new URL(link.href);
    const path = url.pathname;
    const fragments = path.split('/');
    return fragments.pop() || '';
}
